import React from "react"

export default function Footer() {
    return (
        <footer>
            <p>© Kai Pereira 2022 </p>
            <img src="Logo.png" alt="logo"/>
            <p>Privacy Policy</p>
        </footer>
    )
}